import icons from "helpers/icons";
import scss from "./AddToCardButton.module.scss";
import LoadingWrapper from "../../Loading/LoadingWrapper";
import { useTranslation } from "react-i18next";
import { isPurchaseAllowed } from "../../../helpers/product";

const AddToCartButton = ({ onClick, type = "button", short = true, className, product, productVariant, location, loading, translateKey }) => {
    const { t } = useTranslation();

    const item = productVariant ?? product;
    const can_purchase = item?.inventory?.inventory_defined && item?.price?.price_defined && isPurchaseAllowed(item?.behaviours?.cart);

    return (
        <>
            <button disabled={loading ? true : false} style={{ zIndex: `1` }} className={`btn-basic relative btn-basic-secondary ${scss.button} ${className}`} type={type} onClick={onClick}>
                <LoadingWrapper isLoading={loading} type="spin" size={20} color={"#fff"} className={loading ? `${scss.loading}` : `${scss.wrapper} ${scss.wrappernopadding}`}></LoadingWrapper>
                <div className={loading ? scss.loading2 : ``}>
                    <span>{can_purchase ? (short ? t(`${translateKey}-cart_short`) : t(`${translateKey}-cart_long`)) : <span>{t(`${translateKey}-contact_link`)}</span>}</span>
                    <img src={icons.cart} alt="" />
                </div>
            </button>
        </>
    );
};

export default AddToCartButton;
